/**
 * Utilidades para mostrar fechas relativas en español.
 *
 * "hace 5 min" / "hace 2 h" / "hace 3 días" / fecha completa para más antigüedad.
 */

/**
 * Devuelve una string "hace X" relativa a ahora.
 *
 * @param {string|Date} dateInput  Fecha ISO o Date
 * @returns {string}  Texto humano, p.ej. "hace 5 min", "hace 2 h", "hace 3 d"
 */
export function relativeTimeEs(dateInput) {
  if (!dateInput) return '';
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return '';

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);

  if (diffSec < 60) return 'hace unos seg';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `hace ${diffMin} min`;
  const diffHours = Math.floor(diffMin / 60);
  if (diffHours < 24) return `hace ${diffHours} h`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `hace ${diffDays} día${diffDays === 1 ? '' : 's'}`;
  // Más de 7 días: formato local completo
  return date.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}

/**
 * Indica si la fecha está dentro de las últimas X horas (por defecto 24h).
 */
export function isRecent(dateInput, hours = 24) {
  if (!dateInput) return false;
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return false;
  const diffHours = (Date.now() - date.getTime()) / (1000 * 60 * 60);
  return diffHours >= 0 && diffHours < hours;
}
